import { useEffect, useState } from "react";
import { cachedGet } from "@/lib/offline";
import { Loader } from "@/components/ui-kit";
import { Lightbulb, Phone, Package } from "lucide-react";

export default function Recommendations({ tourId, compact }) {
  const [d, setD] = useState(null);
  useEffect(() => { cachedGet(`/itinerant/recommendations${tourId ? `?tournee_id=${tourId}` : ""}`).then(setD).catch(() => setD({ items: [] })); }, [tourId]);
  if (!d) return <Loader />;
  if (!d.items.length) return <p className="text-xs text-slate-400" data-testid="reco-empty">Aucune visite recommandée pour le moment.</p>;
  const items = compact ? d.items.slice(0, 5) : d.items;
  return (
    <div className="space-y-2" data-testid="reco-list">
      {items.map((it, i) => (
        <div key={it.id} className="rounded-lg border p-3" data-testid={`reco-item-${i}`}>
          <div className="flex items-start justify-between gap-2">
            <div>
              <p className="font-semibold text-sm">{it.nom} {it.type === "prospect" && <span className="ml-1 rounded-full bg-amber-100 px-2 text-[10px] text-amber-700">Prospect</span>}</p>
              <p className="text-xs text-slate-500">{it.raisons.join(" · ")}</p>
              <p className="text-[11px] text-slate-400">Dernier achat : {it.dernier_achat || "—"} {it.potentiel && `· Potentiel ${it.potentiel}`}</p>
            </div>
            {it.telephone && <a href={`tel:${it.telephone}`} className="shrink-0 rounded-full border p-2 text-brand-700"><Phone className="h-4 w-4" /></a>}
          </div>
          {it.produits.length > 0 && <div className="mt-2 flex flex-wrap gap-1">
            {it.produits.map((p) => <span key={p.article_id} className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] ${p.en_stock > 0 ? "bg-brand-50 text-brand-700" : "bg-slate-100 text-slate-500"}`}>
              <Package className="h-3 w-3" />{p.designation}{p.en_stock > 0 ? ` (${p.en_stock} en stock)` : " (à commander)"}</span>)}
          </div>}
        </div>
      ))}
    </div>
  );
}

export function RecoHeader() {
  return <span className="inline-flex items-center gap-1"><Lightbulb className="h-4 w-4 text-amber-500" />Visites recommandées aujourd'hui</span>;
}
